import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  PROFILE: {
    path: `${baseRoutes.userBaseRoutes}profile`,
    icon: "icon-profile-user",
  },
};

export default accessRoute;
